import * as React from 'react'
import { connect } from 'react-redux'
import { ContactFormComponent } from './ContactForm'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const formName = 'contactForm'

export interface IContactFormContainerProps {
  onAfterSubmit: () => undefined
  initialValues?: object
}

const stateToProps = () => ({})

export const dispatchToProps = {}

export const ContactForm = flow<any, any, React.SFC<IContactFormContainerProps>>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(ContactFormComponent)



// WEBPACK FOOTER //
// src/features/Contact/ContactForm/ContactForm.container.ts